module.exports = __webpack_public_path__ + "img/dial1.a1038869.png";